import { GetLomdaV3ResponseType } from "../hooks/useGetLomdaV3";
import GeneralTab from "./tabs/general";
import LomdaV3Thumbnail from "@/app/[locale]/(platform)/storage/components/lomdaV3/lomdaV3Thumbnail";

export default function LomdaV3SheetMain({
    lomda,
}: {
    lomda: GetLomdaV3ResponseType["data"];
}) {
    return (
        <main className="flex min-w-0 flex-1 flex-col py-4 px-8 gap-4">
            <div className="relative aspect-video rounded-md border overflow-hidden">
                <LomdaV3Thumbnail
                    lomda={lomda}
                    lomdaId={lomda?.id ?? ""}
                    lomdaName={lomda?.name ?? ""}
                />
            </div>
            <GeneralTab lomda={lomda} />
            <div className="pb-8" />
        </main>
    );
}
